import React, { useState, useEffect } from 'react';
    import { motion } from 'framer-motion';
    import { Link, useLocation, useNavigate } from 'react-router-dom';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiMenu, FiX } = FiIcons;

    const Navigation = () => {
      const [isScrolled, setIsScrolled] = useState(false);
      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      const location = useLocation();
      const navigate = useNavigate();

      useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);

      const handleSectionNavigation = (sectionId) => {
        if (location.pathname === '/') {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        } else {
          navigate(`/#${sectionId}`);
        }
        setIsMobileMenuOpen(false);
      };

      const handleBookingClick = () => {
        window.open('https://connect.withjahx.com', '_blank');
        setIsMobileMenuOpen(false);
      };

      const handleLinkClick = () => {
        setIsMobileMenuOpen(false);
        // Scroll to top when navigating to new page
        window.scrollTo(0, 0);
      };

      return (
        <motion.nav
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
            isScrolled ? 'bg-gray-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
          }`}
        >
          <div className="container mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <Link to="/" onClick={handleLinkClick}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center space-x-3"
                >
                  <img src="https://storage.googleapis.com/msgsndr/5HRQzDMwpTPxnC7Itr8Z/media/6836617cb09b43dcbc66db28.svg" alt="Clarity with Jahx Logo" className="w-10 h-10" />
                  <span className="font-orbitron text-xl font-bold clarity-gradient">
                    Clarity with Jahx
                  </span>
                </motion.div>
              </Link>

              {/* Desktop Menu */}
              <div className="hidden md:flex items-center space-x-8">
                <button
                  onClick={() => handleSectionNavigation('ecosystem')}
                  className="text-gray-300 hover:text-white transition-colors font-poppins"
                >
                  Ecosystem
                </button>
                <button
                  onClick={handleBookingClick}
                  className="text-gray-300 hover:text-white transition-colors font-poppins"
                >
                  Book a Call
                </button>
                <button
                  onClick={() => handleSectionNavigation('about')}
                  className="text-gray-300 hover:text-white transition-colors font-poppins"
                >
                  About
                </button>
                <a href="https://discord.withjahx.com" target="_blank" rel="noopener noreferrer">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-2 rounded-full font-poppins font-medium glow-button"
                  >
                    Join for $5.55
                  </motion.button>
                </a>
              </div>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden text-white"
              >
                <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
              </button>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="md:hidden mt-4 py-4 bg-gray-800/95 rounded-lg backdrop-blur-md"
              >
                <div className="flex flex-col space-y-4 px-4">
                  <button
                    onClick={() => handleSectionNavigation('ecosystem')}
                    className="text-gray-300 hover:text-white transition-colors font-poppins text-left"
                  >
                    Ecosystem
                  </button>
                  <button
                    onClick={handleBookingClick}
                    className="text-gray-300 hover:text-white transition-colors font-poppins text-left"
                  >
                    Book a Call
                  </button>
                  <button
                    onClick={() => handleSectionNavigation('about')}
                    className="text-gray-300 hover:text-white transition-colors font-poppins text-left"
                  >
                    About
                  </button>
                  <a href="https://discord.withjahx.com" target="_blank" rel="noopener noreferrer" className="w-full">
                    <button className="bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-2 rounded-full font-poppins font-medium text-center w-full">
                      Join for $5.55
                    </button>
                  </a>
                </div>
              </motion.div>
            )}
          </div>
        </motion.nav>
      );
    };

    export default Navigation;